import { Injectable } from "@angular/core";
import { ENCODABLE_TYPE_ERRORS } from "shared/broker-client-services";
import {
  PRIMITIVE,
  ClientMessageBrokerFactory,
  ClientMessageBroker,
  FnArg,
  UiArguments,
  FnTransferableArg,
} from "shared/provider-webworker";
import { ISystemMessageService, SYSTEM_MESSAGE_TYPE } from "../ISystemMessageService";
import { Observable, ReplaySubject } from "rxjs";
import { Product, Tenor } from "shared/cubiq-model-multi-asset";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { CubiqSerializer } from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class SystemMessageReplicaService implements ISystemMessageService {
  private broker: ClientMessageBroker;
  private systemMessageSubject: ReplaySubject<CubiqTS.SystemMessage> =
    new ReplaySubject<CubiqTS.SystemMessage>(1);

  constructor(private factory: ClientMessageBrokerFactory, private serializer: CubiqSerializer) {
    this.initialize();
  }

  private initialize(): void {
    const ENCODABLE_TYPE = new CubiqTS.SystemMessageImpl();

    this.broker = this.factory.createMessageBroker(SYSTEM_MESSAGE_TYPE, true, true);

    let refreshChannel = new MessageChannel();
    let clientRefreshPort: MessagePort = refreshChannel.port1;
    let serviceRefreshPort: MessagePort = refreshChannel.port2;

    let request = new UiArguments("initPort", [
      new FnTransferableArg(serviceRefreshPort, PRIMITIVE),
    ]);

    clientRefreshPort.addEventListener("message", (message: any) => {
      if (message && message.data && message.data instanceof ArrayBuffer) {
        let event = this.serializer.deserialize(message.data, ENCODABLE_TYPE);

        if (event && event instanceof CubiqTS.SystemMessageImpl) {
          this.systemMessageSubject.next(event);
        }
      }
    });

    this.broker.runOnService(request, null);
    clientRefreshPort.start();
  }

  public getSystemMessages(): Observable<CubiqTS.SystemMessage> {
    return this.systemMessageSubject.asObservable();
  }

  private runOnService(request: UiArguments, map: any = null): Promise<any> {
    return new Promise<any>((res, rej) => {
      this.broker.runOnService(request, PRIMITIVE).then((value: any) => {
        if (value && value.enType && value.enType == ENCODABLE_TYPE_ERRORS) {
          rej(value);
        } else {
          if (map && value) {
            if (value instanceof Array) {
              let values: Array<any> = value as Array<any>;
              values = values.map(map);
            } else {
              value = map(value);
            }
          }
          res(value);
        }
      });
    });
  }
}
